/**
 * index.tsx
 * [Readme] --------------------------------------------------------------------------------------
 * 
 * React 앱을 시작/구축하기 위한 react-scripts의 진입점.
 * public/index.html에서 <div id="root"></div> 영역에 붙는 가장 최초의 내용입니다.
 * ※웬만한 경우 이 영역을 조작할 필요는 없습니다.
 * 
 * -----------------------------------------------------------------------------------------------
 */

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { configure } from 'mobx';

configure({
  useProxies: 'never'
});

import { gsap } from 'gsap/dist/gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';

window.requestAnimationFrame = window.requestAnimationFrame.bind(window);
gsap.registerPlugin(ScrollTrigger);

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { RecoilRoot } from 'recoil';
import DesktopGlobalStyle from 'common-modules/general/assets/Styles/Desktop/globalStyels';
import MobileGlobalStyle from 'common-modules/general/assets/Styles/Mobile/globalStyels';
import { isMobile } from 'react-device-detect';
import { EndPointURL, REAL_END_POINT } from 'common-modules/general/Config/constants';
import 'common-modules/general/assets/fontFace.scss';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import ToasterContainer from 'common-modules/general/Common/Components/Toaster/ToasterContainer'; 

ReactDOM.render(
  <React.StrictMode>
    <ToasterContainer isMobile={isMobile} />
    <RecoilRoot>
      {!isMobile ? <DesktopGlobalStyle /> : <MobileGlobalStyle />}
      <Router>
        <App />
      </Router>
    </RecoilRoot>
  </React.StrictMode>,
  document.getElementById('root')
);

/**
 * CRA(Create-React-App)으로 생성한 리액트 프로젝트의 서드파티 라이브러리인 Web Vitals의 사용을 지정한다.
 * Web Vitals는 웹 퍼포먼스 측정도구롤 web-vitals 이란 모듈을 사용하며 이를 통해 측정값이 계산된 내용을 console.log로 활성화 할 수 있다.
 * 
 * @ref https://www.npmjs.com/package/web-vitals
 */
if (EndPointURL !== REAL_END_POINT) {
  reportWebVitals();
}
